import { RegistrationStatus } from 'libs/utils/src/lib/player-portals/constants/pp-registration-constants';
import styles from '../PlayerPortalsOnSiteRegistrationAdminPanel.module.scss';

export const getRegistrationStatusClass = (status: any) => {
  if (status === null || status === undefined) {
    return '';
  }
  switch (status.toString()) {
    case RegistrationStatus.NotRegistered:
      return styles.notRegistered;
    case RegistrationStatus.PreRegistrationComplete:
      return styles.preRegistrationComplete;
    case RegistrationStatus.Registered:
      return styles.registered;
    default:
      return '';
  }
};

export default getRegistrationStatusClass;
